export function canEditV5075SnWhitelist(mode) {
  return String(mode || '').trim().toLowerCase() === 'sn';
}

export function getV5075SnWhitelistPlaceholder(mode) {
  return canEditV5075SnWhitelist(mode)
    ? '输入接头 SN'
    : '切换到“指定 SN”后可添加';
}
